
import linkExpiredImage from "~/assets/images/linkExpiredImage.svg";
import dialogCloseBtn from "../../components/common/dialog-close-btn.vue";
import order from "../../mixins/order";
export default {
  components: { dialogCloseBtn },
  layout: "blankOrder",
  mixins: [order],
  data() {
    return {
      linkExpiredImage,
      loading: false
    };
  },
  methods: {
    handleCloseButtonClick() {
      this.$router.go(-1);
    }
  }
};
